export default "__VITE_ASSET__BTOW0KsB__"